import NotificationsListPageContainer from './containers/NotificationsListPageContainer'

export default NotificationsListPageContainer
